import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ProgressBarService } from './progress-bar.service';
import { tap } from 'rxjs/operators';

/**
 * Start progress bar on http requests, end them after success or error.
 */
@Injectable()
export class ProgressInterceptor implements HttpInterceptor {
  private progressBarService = inject(ProgressBarService);


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.progressBarService.start();

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.progressBarService.stop();
          }
        },
        (_: any) => {
          this.progressBarService.stop();
        },
      ),
    );
  }
}
